import { registerStore } from '@owlsdepartment/vuex-typed';
import { createStore, StoreOptions } from 'vuex';

import { registerStoreForHelpers } from './helpers/storeInstance';

export function initStore<T>(options: StoreOptions<T>) {
	const store = createStore(options);

	registerStore(store);
	registerStoreForHelpers(store);

	return store;
}
